import React from 'react'
import { Field, reduxForm } from 'redux-form'

import { Input } from 'Components/Form/Input/index'
import SubmitButton from 'Components/Form/SubmitButton'
import { validate } from './validate'
import { MessageError } from 'Components/Message/Error'

export let ForgotPasswordFormUnstyled = props => {
  return (
    <div className={props.className}>
      <form>
        <h1>Forgot Password?</h1>
        <p>
          Please enter your email below to receive your password reset
          instructions
        </p>
        {renderGeneralErrorMessage()}
        <div className="form-inputs">
          <Field
            name="email"
            type="text"
            component={Input}
            icon="email"
            id="email"
            placeholder="Your email address"
          />
        </div>
        <SubmitButton value="Reset Password" onClick={props.handleSubmit} />
      </form>
    </div>
  )

  /**
   * Render general error message
   *
   * @returns JSX.Element | null
   */
  function renderGeneralErrorMessage() {
    return props.errorMessage ? (
      <MessageError message={props.errorMessage} />
    ) : null
  }
}

ForgotPasswordFormUnstyled = reduxForm({
  // a unique name for the form
  form: 'forgotPassword',
  validate: validate,
})(ForgotPasswordFormUnstyled)



// WEBPACK FOOTER //
// ./src/Containers/Form/ForgotPassword/unstyled.js